
import { mapState, mapMutations } from 'vuex'
export default class {
  static install (Vue) {
    Vue.mixin({
      computed : {
        ...mapState('app', {
          $user            : state => state.User,
          $company         : state => state.Company,
          $currentStore    : state => state.Store,
          userPermissions  : state => state.userPermissions,
          assignedStoreIds : state => state.assignedStoreIds
        }),
        namespace(){
          return this.$route.matched[0].props.default.namespace
        }
      },
      methods : {
        //+++ this block of code is used for handling forms events and delete popup +++//
        ...mapMutations({
          hideForm        : 'app/HIDE_FORM',
          hideDeletePopup : 'app/HIDE_DELETE_POPUP'
        }),
        showForm(id = null){
          this.$store.dispatch('app/showForm', { id, namespace : this.namespace })
        },
        showDeletePopup(id = null){
          this.hideForm()
          this.$nextTick(()=> {
            this.$store.commit('app/SHOW_DELETE_POPUP', { id, namespace : this.namespace })
          })
        },
        //+++ end +++//
        $can(permission, store = this.$currentStore){
          let hasStorePermission = true

          if(permission.toLowerCase().includes('ownstore')){
            hasStorePermission = this.assignedStoreIds.includes(store.id)
          }

          return (this.userPermissions.roles.superadmin || this.$user.id === this.$company.managerId ||
            (this.userPermissions.permissions[permission] && this.$user.companyId === this.$company.id && hasStorePermission))
        },
        isModuleEnabled(moduleCode){
          return this.$company.EnabledModules
            .find(ml => ml.moduleCode === moduleCode) && !(this.$currentStore.DisabledModules || [])
            .find(m => m.moduleCode === moduleCode) 
        },
        isModuleEnabledForCompany (moduleCode) {
          return !!this.$company.EnabledModules
            .find(ml => ml.moduleCode === moduleCode)
        },
      },
    })
  }
}
